import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getWaiverSubmissionsByTripBooking, postSharedWaiver } from "store/digital-waiver"
import { toaster } from "components/common/Toast"

const transformGuestDataToPayload = (guests) => {
  const sharedWaiverArray = []

  guests?.forEach((guest) => {
    if (guest.sendMethod === "text") {
      guest.phones?.forEach((phone) => {
        if (phone?.fullNumber?.trim()) {
          sharedWaiverArray.push({
            share_by: "text",
            phone_number: phone.fullNumber
          })
        }
      })
    } else if (guest.sendMethod === "email") {
      guest.emails?.forEach((email) => {
        if (email?.trim()) {
          sharedWaiverArray.push({
            share_by: "email",
            email: email
          })
        }
      })
    }
  })

  return sharedWaiverArray
}

export const useShareWaiverSubmission = (tripBookingId,uuid, onSuccess, onError) => {
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.digitalWaiver)

  const submitWaiver = useCallback(async (values) => {
    try {
      const sharedWaiverArray = transformGuestDataToPayload(values.guests)
      
      const payload = {
        trip_booking_id: tripBookingId,
        shared_waiver: sharedWaiverArray
      }

      const response = await dispatch(postSharedWaiver(payload))
      dispatch(getWaiverSubmissionsByTripBooking(uuid))
      toaster.success(response.message)
      onSuccess?.()
      
      return { success: true, data: response }
    } catch (error) {
      onError?.(error)
      return { success: false, error }
    }
  }, [dispatch, tripBookingId, onSuccess, onError])

  return {
    submitWaiver,
    loading
  }
}
